<div class="app-full-height px-4 pt-4">
  <div class="flex flex-row justify-end items-center py-4">
    <button
      mat-raised-button
      color="primary"
      [routerLink]="['/workshop', 'templates']"
    >
      Job Templates
    </button>
  </div>
  <app-workshop-list-filter></app-workshop-list-filter>
  <app-workshop-job-list></app-workshop-job-list>
</div>
